/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPSOURCEOFFUNDS } from './IAPSOURCEOFFUNDS';
import {
    IAPSOURCEOFFUNDSFromJSON,
    IAPSOURCEOFFUNDSFromJSONTyped,
    IAPSOURCEOFFUNDSToJSON,
} from './IAPSOURCEOFFUNDS';

/**
 * 
 * @export
 * @interface PaymentDetailsSourceOfMoneyViewModel
 */
export interface PaymentDetailsSourceOfMoneyViewModel {
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsSourceOfMoneyViewModel
     */
    id?: number;
    /**
     * 
     * @type {IAPSOURCEOFFUNDS}
     * @memberof PaymentDetailsSourceOfMoneyViewModel
     */
    sourceOfMoney: IAPSOURCEOFFUNDS;
    /**
     * 
     * @type {string}
     * @memberof PaymentDetailsSourceOfMoneyViewModel
     */
    otherDescription?: string;
}

/**
 * Check if a given object implements the PaymentDetailsSourceOfMoneyViewModel interface.
 */
export function instanceOfPaymentDetailsSourceOfMoneyViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sourceOfMoney" in value;

    return isInstance;
}

export function PaymentDetailsSourceOfMoneyViewModelFromJSON(json: any): PaymentDetailsSourceOfMoneyViewModel {
    return PaymentDetailsSourceOfMoneyViewModelFromJSONTyped(json, false);
}

export function PaymentDetailsSourceOfMoneyViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentDetailsSourceOfMoneyViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'sourceOfMoney': IAPSOURCEOFFUNDSFromJSON(json['SourceOfMoney']),
        'otherDescription': !exists(json, 'OtherDescription') ? undefined : json['OtherDescription'],
    };
}

export function PaymentDetailsSourceOfMoneyViewModelToJSON(value?: PaymentDetailsSourceOfMoneyViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'SourceOfMoney': IAPSOURCEOFFUNDSToJSON(value.sourceOfMoney),
        'OtherDescription': value.otherDescription,
    };
}

